// extracted by mini-css-extract-plugin
export var aboutHeader = "about-module--about-header--69f05";
export var accomplishment = "about-module--accomplishment--f02ea";
export var border = "about-module--border--ea7a6";
export var btn = "about-module--btn--29bf5";
export var btnAbsolute = "about-module--btnAbsolute--c1a5f";
export var center = "about-module--center--7bd82";
export var gatsbyImage = "about-module--gatsby-image--043fb";
export var headerBorder = "about-module--header-border--38529";
export var headerImg = "about-module--header-img--25303";
export var heading = "about-module--heading--6bce0";
export var headingSubtitle = "about-module--heading-subtitle--a5ecb";
export var headingTitle = "about-module--heading-title--42fba";
export var imageLinks = "about-module--image-links--59fe9";
export var imgResponsive = "about-module--img-responsive--df156";
export var inlineBlock = "about-module--inline-block--389f8";
export var inner = "about-module--inner--4acab";
export var socialLinks = "about-module--social-links--59104";
export var socialRight = "about-module--social-right--fb82a";
export var socialSectionTriangle = "about-module--socialSectionTriangle--9f8eb";
export var teamSection = "about-module--teamSection--e7727";
export var textDark = "about-module--text-dark--d7707";
export var whatWeDo = "about-module--whatWeDo--72397";